try {
    require('./init')
    const Form = require('./form')
    const View = require('./view')
    const ExtensionService = require('live/services/extension')

    const witsml_qgog = {
        name: 'QGOG WITSML Export',
        type: 'liverig-witsml-qgog',
        origin: 'Plugin Petrobras',
        roles: ['output'],
        icon: '/content/plugin-petrobras/witsml-qgog.png',
        ui: {
            form: Form,
            view: View
        }
    }

    ExtensionService.register(witsml_qgog)
} catch (e) {
    console.error(e)
}
